<template>
  <div class="dialog-wrap">
    <el-dialog
      title="拼团规则"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="handleClose"
      width="480px">
      <el-form class="form" :model="dataForm" label-position="top" :rules="rules" ref="dataForm" label-width="100px">
        <el-form-item label="拼团规则" prop="value">
          <el-input v-model="dataForm.value" type="textarea" :autosize="{ minRows: 10, maxRows: 20}" placeholder="请输入拼团规则"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { configureOne, configureCreate, configureUpdate } from '@/api/operation'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      dataForm: {
        name: '拼团规则',
        code: 'ActivityRule',
        value: ''
      },
      rules: {
        value: [{ required: true, message: '请输入拼团规则', trigger: 'blur' }]
      }
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val

      if (val) {
        this.fetchActivityRule()
      }
    },
  },
  methods: {
    fetchActivityRule() {
      configureOne({code: 'ActivityRule'}).then(res => {
        console.log(res)
        if (res) {
          this.dataForm = res
        }
      })
    },
    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const params = {
            name: this.dataForm.name,
            code: this.dataForm.code,
            value: this.dataForm.value,
          }
          if (this.dataForm.id) {
            params.id = this.dataForm.id
            configureUpdate(params).then(res => {
              this.$message.success(`编辑成功`)
              this.$refs['dataForm'].resetFields()

              this.$emit('submit')
              this.handleClose()
            }).catch(error => {
              console.log('error: ', error)
            })
          } else {
            configureCreate(params).then(res => {
              this.$message.success(`编辑成功`)
              this.$refs['dataForm'].resetFields()

              this.$emit('submit')
              this.handleClose()
            }).catch(error => {
              console.log('error: ', error)
            })
          }

        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleClose() {
      this.$emit('close')
    },
  }
}
</script>

<style lang="less" scoped>
  .dialog-wrap {

    .form {
      margin-bottom: -18px;
    }
  }
</style>
